angular.module('cfn').factory('genericFarmMapService', function() {
  var plugins = {};

  // Public
  return {
    getPlugins: function() {
      var result = [];
      var i = 0;
      for (var name in plugins) {
        result[i++] = plugins[name];
      }
      return result;
    },

    getPluginByName: function(name) {
      return plugins[name];
    },

    registerPlugin: function(plugin) {
      plugins[plugin.name] = plugin;
    },

    checkPluginsEnabled: function() {
      for (var name in plugins) {
        var plugin = plugins[name];
        if (plugin.checkEnabled) {
          plugin.checkEnabled();
        }
      }
    }
  };
});
